module.exports = "/images/laser tag.svg?3747838e21bf9fb202bf1fcd3ab34f22";